import Scroll from './scroll-wrap'

Scroll.install = function (Vue) {
    Vue.component(Scroll.name,Scroll)
}
export default Scroll
